import apiClient from '../axiosConfig';
import { components } from '../types/openapi';

// Tipos del OpenAPI
type Permission = components['schemas']['Permission'];
type PermissionResponse = components['schemas']['PermissionResponse'];
type UpdatePermission = components['schemas']['UpdatePermission'];
type PaginationPermission = components['schemas']['Pagination_Permission_'];

/**
 * Servicio de gestión de permisos
 * Maneja todas las operaciones CRUD de permisos
 * Basado en los endpoints del OpenAPI
 */
class PermissionService {
  /**
   * Obtener lista de permisos
   * GET /api/users/permissions/
   */
  async getPermissions(params?: {
    limit?: number;
    name?: string;
  }): Promise<Permission[]> {
    const response = await apiClient.get<Permission[]>('/users/permissions/', { params });
    return response.data;
  }

  /**
   * Obtener todos los permisos
   * GET /api/users/permissions/all
   */
  async getAllPermissions(params?: {
    name?: string;
  }): Promise<Permission[]> {
    const response = await apiClient.get<Permission[]>('/users/permissions/all', { params });
    return response.data;
  }

  /**
   * Obtener permisos con paginación
   * GET /api/users/permissions/pagination
   */
  async getPermissionsPaginated(params?: {
    page?: number;
    limit?: number;
    name?: string;
  }): Promise<PaginationPermission> {
    const response = await apiClient.get<PaginationPermission>('/users/permissions/pagination', { params });
    return response.data;
  }

  /**
   * Obtener un permiso por ID
   * GET /api/users/permissions/{permission_id}
   */
  async getPermissionById(permissionId: number): Promise<Permission> {
    const response = await apiClient.get<Permission>(`/users/permissions/${permissionId}`);
    return response.data;
  }

  /**
   * Actualizar un permiso
   * PUT /api/users/permissions/
   */
  async updatePermission(permissionData: UpdatePermission): Promise<unknown> {
    const response = await apiClient.put('/users/permissions/', permissionData);
    return response.data;
  }

  /**
   * Cambiar estado de un permiso (activar/desactivar)
   * POST /api/users/permissions/change-state/{permission_id}
   */
  async changePermissionState(permissionId: number): Promise<Permission> {
    const response = await apiClient.post<Permission>(`/users/permissions/change-state/${permissionId}`);
    return response.data;
  }
}

export default new PermissionService();

